<template>
  <div :class="`drawer-container ${wrapperState}`" @click.self="handleClose">
    <div :class="`drawer ${wrapperState}`">
      <slot name="content" />

      <div class="drawer__back-button-wrapper">
        <VButton text="Voltar" variant="secondary" size="lg" @click.native="handleClose" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    open: { type: Boolean, default: false },
  },
  computed: {
    wrapperState() {
      return !this.open ? '--closed' : '--open';
    },
  },
  methods: {
    handleClose() {
      this.$emit('close', this.$event);
    },
  },
};
</script>

<style lang="scss" scoped>
.drawer-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.3);
  transition: all 0.3s ease-in;

  &.--closed {
    transition: all 0.3s ease-in 0.3s;
    z-index: -1;
    opacity: 0;
  }

  &.--open {
    z-index: 100;
    opacity: 1;
  }
}
.drawer {
  position: fixed;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 100%;
  max-width: 576px;

  display: flex;
  flex-direction: column;
  align-items: center;
  background: white;
  padding: 24px;
  border-radius: 8px 8px 0 0;
  box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.3);
  transition: all 0.3s ease-in;

  &.--closed {
    transform: translate(-50%, 100%);
  }

  &.--open {
    transform: translateX(-50%);
  }

  .drawer__back-button-wrapper {
    margin-top: 24px;
    width: 100%;
    max-width: 312px;
  }
}

.drawer-info {
  &__title {
    font-size: 20px;
    color: #363636;
    font-weight: var(--font-weight-bold, 700);
    margin-bottom: 26px;
  }

  &__text {
    font-size: 16px;
    color: #797c86;
    line-height: 1.5;
    margin-bottom: 12px;

    &:last-of-type {
      margin-bottom: 0;
    }
  }
}
</style>
